// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3nFJn","selected":"Chip_selected__1g2ff"};